import { render, staticRenderFns } from "./trangchu1.vue?vue&type=template&id=6778ec3a&"
import script from "./trangchu1.vue?vue&type=script&lang=js&"
export * from "./trangchu1.vue?vue&type=script&lang=js&"
import style0 from "./trangchu1.vue?vue&type=style&index=0&id=6778ec3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports